import { render } from "./OracleComponent.vue?vue&type=template&id=50662b9c&scoped=true"
import script from "./OracleComponent.vue?vue&type=script&lang=js"
export * from "./OracleComponent.vue?vue&type=script&lang=js"

import "./OracleComponent.vue?vue&type=style&index=0&id=50662b9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50662b9c"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QDialog,QLayout});
